import { Stack, Switch } from '@mantine/core'
import { featureFlags } from '@seen/core/featureFlags'
import type { JSX } from 'react'
import { setDemoModeAndReload } from '#src/demo-mode/installDemoMode.ts'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export function DevTools(): JSX.Element {
  const showLinkOverlay = usePortalStore((state) => state.showLinkOverlay)
  const toggleLinkOverlay = usePortalStore((state) => state.toggleLinkOverlay)
  const showEnvironmentLogo = usePortalStore(
    (state) => state.showEnvironmentLogo
  )
  const toggleEnvironmentLogo = usePortalStore(
    (state) => state.toggleEnvironmentLogo
  )
  const showDemoPatientsOnly = usePortalStore(
    (state) => state.showDemoPatientsOnly
  )
  const toggleDemoPatientsOnly = usePortalStore(
    (state) => state.toggleDemoPatientsOnly
  )
  const showAdminActions = usePortalStore((state) => state.showAdminActions)
  const toggleAdminActions = usePortalStore((state) => state.toggleAdminActions)

  const showReactQueryDevtools = usePortalStore(
    (state) => state.showReactQueryDevtools
  )
  const toggleReactQueryDevtools = usePortalStore(
    (state) => state.toggleReactQueryDevtools
  )
  const demoMode = usePortalStore((state) => state.demoMode)
  const demoModeEnabled = useFeatureFlag(featureFlags.demoMode)
  const showMemo = usePortalStore((state) => state.showMemo)
  const toggleMemo = usePortalStore((state) => state.toggleMemo)
  return (
    <Stack>
      <Switch
        label="Link Overlay"
        checked={showLinkOverlay}
        onChange={toggleLinkOverlay}
      />
      <Switch
        label="Admin Actions"
        checked={showAdminActions}
        onChange={toggleAdminActions}
      />
      <Switch
        label="Environment Logo"
        checked={showEnvironmentLogo}
        onChange={toggleEnvironmentLogo}
      />
      <Switch
        label="Show Demo Patients Only"
        checked={showDemoPatientsOnly}
        onChange={toggleDemoPatientsOnly}
      />
      {demoModeEnabled && (
        <Switch
          label="Demo Mode (hide PHI)"
          description="Reloads the page"
          checked={demoMode}
          onChange={(event) =>
            setDemoModeAndReload(event.currentTarget.checked)
          }
        />
      )}
      <Switch
        label="React Query Devtools"
        checked={showReactQueryDevtools}
        onChange={toggleReactQueryDevtools}
      />
      <Switch label="Memo" checked={showMemo} onChange={toggleMemo} />
    </Stack>
  )
}
